import React from 'react';
import { Global } from '@emotion/core';
import { Footer } from 'client/components/Footer';
import {
  Header,
  BrandPartners,
  Carousel,
  FAQ,
  Glossary,
  Quote,
  SellingPoints,
  Video,
} from 'client/screens/AdsByAnchorScreen/components';
import { MarketingHeaderBackground } from 'client/components/MarketingPagesShared/MarketingHeaderBackground';
import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { hexToRgb, rgbToRgbaString } from 'client/modules/ColorUtils';
import { connect } from 'react-redux';
import { receivePageMetadata as receivePageMetadataImport } from 'client/pageMetadata';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { adsByAnchorPageStyles } from './styles';

const headerColor = rgbToRgbaString(hexToRgb(COLOR_GREEN)!);

type PageMetadata = {
  description?: string;
  image?: string;
  twitterImage?: string;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, Action>) => ({
  receivePageMetadata: (metadata: PageMetadata) =>
    dispatch(receivePageMetadataImport(metadata)),
});

export function AdsByAnchorScreenComponent() {
  return (
    <>
      <Global styles={adsByAnchorPageStyles} />
      <MarketingHeaderBackground color={headerColor} />
      <div className="pageContainer">
        <Header />
        <SellingPoints />
        <Video />
        <Carousel />
        <Quote />
        <BrandPartners />
        <FAQ />
        <Glossary />
      </div>
      <Footer />
    </>
  );
}

class AdsByAnchorScreenClassComponent extends React.Component<{
  receivePageMetadata: (metadata: PageMetadata) => void;
}> {
  /**
   * TODO: Replace this with react helmet
   * https://anchorfm.atlassian.net/browse/PODRACER-2083
   *
   * SSR page metadata can only work using `UNSAFE_componentWillMount`
   */
  UNSAFE_componentWillMount() {
    const { receivePageMetadata } = this.props;
    receivePageMetadata({
      description:
        'The all-in-one, flexible podcast monetization platform made for everyone, powered by Spotify.',
    });
  }

  render() {
    return <AdsByAnchorScreenComponent />;
  }
}

export const AdsByAnchorScreen = connect(
  null,
  mapDispatchToProps
)(AdsByAnchorScreenClassComponent);
